<template>
  <CompaniesItemPageContent :id="id" />
</template>

<script setup lang="ts">
definePageMeta({
  allowBack: true,
})
const route = useRoute()

const id = Array.isArray(route.params.id)
  ? Number(route.params.id[0])
  : Number(route.params.id)
</script>
